import { useEffect } from "react";
import { Subject } from "rxjs";

export const subjectSnackbar = new Subject();

export default function useSnackbar(snackbarContent) {
  useEffect(() => {
    subjectSnackbar.next(snackbarContent);
  }, [snackbarContent]);
}
